export default () => ({
  loading: false,
  listings: null,
  config: {
    page: 1,
    limit: 10,
    total: null
  },
  onSale: null,
  averagePrice: null,
  sortBy: {
    type: 'daysOnSale',
    order: 'desc',
    label: 'Newest'
  }
})
